import $ from 'jquery';

function toggleFilterDropdown() {
  const filterDropdownAll = document.querySelectorAll(".searchandfilter h4");
  const submitBtn = document.querySelector(".sf-field-submit input");

  if (filterDropdownAll) {
    filterDropdownAll.forEach(filterDropdown => {

      filterDropdown.classList.add('dropdown-toggle', 'btn', 'btn-outline-transparent');
      filterDropdown.addEventListener('click', (e) => {
        e.stopPropagation();
        // Close previously opened dropdowns
        filterDropdownAll.forEach(el => {
          if (el !== filterDropdown) {
            el.classList.remove('show');
          }
        });
        filterDropdown.classList.toggle('show');
      });
    });
    // Allows to close all dropdowns when clicking outside of them or prevent it if clicking inside ul element
    document.addEventListener('click', (e) => {
      filterDropdownAll.forEach(filterDropdown => {
        const ul = filterDropdown.nextElementSibling.contains(e.target);

        if (!ul) {
          filterDropdown.classList.remove('show');
        }
      });
    });
  }

  if (submitBtn) {
    submitBtn.classList.add('btn', 'btn-primary');
  }
}

// Toggle dropdown filters on the "villa" archive page
$(function () {
  if (window.location.pathname.includes('/villas')) {
    toggleFilterDropdown();
  }
});

// Reload filters.js script in order to allow dropdowns to display correctly when submitting search & filter AJAX
const observerTarget = document.querySelector('.villa-listing');

if (observerTarget) {
  const observer = new MutationObserver(() => {
    if (!window.location.pathname.includes('/villas')) return;
    toggleFilterDropdown();
  });

  observer.observe(observerTarget, {
    childList: true,
    subtree: true,
  });
}

// Open contact page on '.infos-supp' clicked
document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('post-type-archive-villa')) {
    document.querySelectorAll('.infos-supp').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        const targetUrl = el.dataset.url;
        if (targetUrl) {
          window.location.href = targetUrl;
        }
      });
    });
  }
});
